import React from "react";
import {Col} from "react-bootstrap";
import InlineForm from "../FromGroup/InlineForm";
import Component from "../../../components/AscComponent";
import CommonTable from "../Table/CommonTable";
import { SketchPicker } from 'react-color'
import reactCSS from 'reactcss'
import "./CategoryElements.css";
import SetDataWithSpeechBubble from "./SetDataWithSpeechBubble";


/**
 * 通話分類名入力アイテム
 * state.nameが必要
 */
export class EditCategoryTitle extends Component {
    render() {
        return (
            <InlineForm
                key = "category_title"
                controlId = "category_title"
                label = {this.props.langText.Body.Title}
                type = "text"
                value = {this.props.state.name}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "name", this.props.charaLimit.Category_name)}
                validationstate = {this.props.state.name ? null : "error"} />
        );
    }
}

/**
 * 通話分類内容入力アイテム
 * state.explanationが必要
 */
export class EditCategoryExplanation extends Component {
    render() {
        return (
            <InlineForm
                key = "category_Explanation"
                controlId = "category_Explanation"
                label = {<SetDataWithSpeechBubble
                    displayData = {this.props.langText.Body.Content}
                    speechBubbleData = {this.props.langText.Message.Category_Content_Explanation}
                    infoIconDisplayFlag = {true}
                    infoIconType = {null}
                    infoIconClassName = "modal-info-icon"
                    infoIconColor = "silver"
                    infoIconSize = "lg"/>}
                type = "text"
                value = {this.props.state.explanation}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "explanation", this.props.charaLimit.Category_explanation)}
                validationstate = {this.props.state.Explanation ? null : "error"} />
        );
    }
}

/**
 * 通話分類背景色入力アイテム
 * state.rgbが必要
 */
export class EditCategoryRgb extends Component {
    render() {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '30px',
                    height: '30px',
                    borderRadius: '2px 2px 2px 2px',
                    background: `${this.props.state.rgb}`,
                    display: 'block'
                }
            }
        });
        return (
            <InlineForm
                key = "category_rgb"
                controlId = "category_rgb"
                label = {this.props.langText.Body.BackgroundColor}
            >
                <Col className="category_rgb">
                    <div>
                        <div className="swatch" onClick={e => handleClick("back_ground", this.props)}>
                            <div style={styles.color} />
                        </div>
                        {this.props.state.rgb_picker ? 
                        <div className="popover">
                            <div className="cover" onClick={e => handleClose("back_ground", this.props)}/>
                            <SketchPicker 
                                color={this.props.state.rgb} 
                                onChange={e => handleChange("back_ground", e, this.props)} 
                                disableAlpha={true}
                                presetColors={this.props.state.backgroundPresetOptions}    
                            />
                        </div> : null}
                    </div>
                    <div>  
                        <div className="swatch category_rgb_reset_button" onClick={e => defaultColorSet("back_ground", this.props)}>
                            <div className="default_set">{this.props.langText.Body.Reset}</div>
                        </div>
                    </div>
                </Col>
            </InlineForm>
        );
    }
}

/**
 * 通話分類文字色入力アイテム
 * state.font_rgbが必要
 */
export class EditCategoryFontRgb extends Component {
    render() {
        const font_styles = reactCSS({
            'default': {
                color: {
                    width: '30px',
                    height: '30px',
                    borderRadius: '2px',
                    background: `${this.props.state.font_rgb}`,
                    display: 'block',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)'
                },
                font_color:{
                    color: `${ this.props.state.font_rgb}`,
                }
            }
        });
        return (
            <InlineForm
                key = "category_font_rgb"
                controlId = "category_font_rgb"
                label = {this.props.langText.Body.TextColor}
            >
                <Col className="category_rgb" xs={4} md={4}>
                    <div>
                        <div className="swatch" onClick={e => handleClick("font", this.props)}>
                            <div style={font_styles.color} />
                        </div>
                        {this.props.state.font_rgb_picker ? 
                        <div className="popover">
                            <div className="cover" onClick={e => handleClose("font", this.props)}/>
                            <SketchPicker 
                                color={this.props.state.font_rgb} 
                                onChange={e => handleChange("font", e, this.props)} 
                                disableAlpha={true}
                                presetColors={this.props.state.fontPresetOptions}
                            />
                        </div> : null }
                    </div>
                    <div>  
                        <div className="swatch category_rgb_reset_button" onClick={e => defaultColorSet("font", this.props)}>
                            <div className="default_set">{this.props.langText.Body.Reset}</div>
                        </div>
                    </div>
                </Col>
            </InlineForm>
        );
    }
}

/**
 * 通話分類名表示アイテム
 * state.nameが必要
 */
export class ViewCategoryTitle extends Component {
    render() {
        return (
            <InlineForm
                key = "category_title"
                controlId = "category_title"
                label = {this.props.langText.Body.Title}
                type = "text"
                value = {this.props.state.name}
                readOnly
            />
        )
    }
}

/**
 * 通話分類内容表示アイテム
 * state.explanationが必要
 */
export class ViewCategoryExplanation extends Component {
    render() {
        return (
            <InlineForm
                key = "category_explanation"
                controlId = "category_explanation"
                label = {this.props.langText.Body.Content}
                type = "text"
                value = {this.props.state.explanation}
                readOnly
            />
        )
    }
}

/**
 * 通話分類背景色表示アイテム
 * state.rgbが必要
 */
export class ViewCategoryRgb extends Component {
    render() {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '30px',
                    height: '30px',
                    borderRadius: '2px 2px 2px 2px',
                    background: `${this.props.state.rgb}`,
                    display: 'block'
                }
            }
        });
        return (
            <InlineForm
                key = "category_rgb"
                controlId = "category_rgb"
                label = {this.props.langText.Body.BackgroundColor}
            >
                <Col className="category_rgb">
                    <div>
                        <div className="swatch">
                            <div style={styles.color} />
                        </div>
                    </div>
                </Col>
            </InlineForm>
        );
    }
}

/**
 * 通話分類文字色表示アイテム
 * state.font_rgbが必要
 */
export class ViewCategoryFontRgb extends Component {
    render() {
        const font_styles = reactCSS({
            'default': {
                color: {
                    width: '30px',
                    height: '30px',
                    borderRadius: '2px',
                    background: `${this.props.state.font_rgb}`,
                    display: 'block',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)'
                },
                font_color:{
                    color: `${ this.props.state.font_rgb}`,
                }
            }
        });
        return (
            <InlineForm
                key = "category_font_rgb"
                controlId = "category_font_rgb"
                label = {this.props.langText.Body.TextColor}
            >
                <Col className="category_rgb" xs={4} md={4}>
                    <div>
                        <div className="swatch">
                            <div style={font_styles.color} />
                        </div>
                    </div>
                </Col>
            </InlineForm>
        );
    }
}

/**
 * 通話分類イメージ表示アイテム
 * state.nameが必要
 */
export class ViewCategoryImage extends Component {
    render() {
        const image_styles = reactCSS({
            'default': {
                swatch: {
                    padding: '3px 5px',
                    borderRadius: '5px',
                    background: `${this.props.state.rgb}`,
                    color: `${this.props.state.font_rgb}`,
                    fontSize: '15px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    width: '100%',
                    height: '100%',
                },
            }
        });

        return (
            <InlineForm
                key="category_image"
                controlId="category_image"
                className="category_image"
                label={this.props.langText.Body.CategoryImage}
            >
                <div className="col-sm-12 margin-top-03 padding-left-0">
                    <span style={image_styles.swatch}>
                        {this.props.state.name ? this.props.state.name : this.props.langText.Message.Category_Image_Placeholder}
                    </span>
                </div>
            </InlineForm>
        )
    }
}

/**
 * 削除項目ビューアイテム
 * state.selectedDataが必要
 */
export class ViewCategoryList extends Component {
    render(){
        return(
            <InlineForm
                key = "category_detail"
                controlId = "category_detail">
                <CommonTable
                    className = "none-overflow"
                    showPagination = {true}
                    defaultPageSize = {10}
                    columns = {[{
                        Header :this.props.langText.Body.CategoryId,
                        accessor: "id",
                    },
                    {
                        Header :this.props.langText.Body.Title,
                        accessor: "name",
                    }]}
                    data = {this.props.state.selectedData}
                />
            </InlineForm>
        );
    }
}

function handleClick(type, props) {
    if (type === "font") {
        props.propSetState({ font_rgb_picker: !props.state.font_rgb_picker })
    } else if (type === "back_ground") {
        props.propSetState({ rgb_picker: !props.state.rgb_picker })
    }
};

function handleClose(type, props) {    
    if (type === "font") {
        props.propSetState({ font_rgb_picker: false })
    } else if (type === "back_ground") {
        props.propSetState({ rgb_picker: false })
    }
};

function handleChange(type, color, props) {
    let {
        propSetState,
        state,
    } = props;

    if (type === "font") {
        if (state.font_rgb !== color.hex) {
            propSetState({ font_rgb: color.hex });
        }
    } else if (type === "back_ground") {
        if (state.rgb !== color.hex) {
            propSetState({ rgb: color.hex });
        }
    }
};

function defaultColorSet(type, props) {
    let {
        propSetState,
        state
    } = props;
    const font_rgb = state.font_rgb;
    const rgb = state.rgb;
    switch (type) {
        case "font":
            if (font_rgb !== state.fontDefaultColors) {
                propSetState({ font_rgb: state.fontDefaultColors })
            }
            break;
        case "back_ground":
            if (rgb !== state.backgroundDefaultColor) {
                propSetState({ rgb: state.backgroundDefaultColor })
            }
            break
        default:
            propSetState({ font_rgb: state.fontDefaultColors })
            propSetState({ rgb: state.fontDefaultColors })
            break;
    }
    
}